import type { RouteObject } from "react-router-dom";
import GlobalMessagesPage, { globalMessagesLoader } from "./List";
import GlobalMessageFormPage, { editGlobalMessageLoader, newGlobalMessageLoader } from "./Form";
import AppError from "../app-error";

export const globalMessagesRoutes: RouteObject[] = [
  { path: "global-messages", Component: GlobalMessagesPage, loader: globalMessagesLoader, errorElement: <AppError /> },
  { path: "global-messages/new", Component: GlobalMessageFormPage, loader: newGlobalMessageLoader, errorElement: <AppError /> },
  { path: "global-messages/:number", Component: GlobalMessageFormPage, loader: editGlobalMessageLoader, errorElement: <AppError /> },
];
